import get from 'transmute/get';
const getMetadata = get('metadata');
export const getOfficeHoursStartTimeFromMessageMetadata = message => {
  var _get;
  const metadata = getMetadata(message);
  if (!metadata) return null;
  return (_get = get('officeHoursStartTime')(metadata)) !== null && _get !== void 0 ? _get : null;
};